import { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import TapIcon from '../../../services/TapIcon';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import Loader from '../../../components/ui/Loader/Loader';
import { toast } from 'react-toastify';

const AddDevice = ({ history }) => {
    const access_token = useSelector(state => state.auth.access_token);
    const [submitLoading, setSubmitLoading] = useState(false)
    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState({
        device_type: "",
        manufactureDeviceId: "",
        deviceModel: "",
        product_serial_number: "",
        deviceIMEI: ""

    })
    const backToListing = () => {
        history.push({ pathname: '/device_listing' });

    }
    const submitDataForm = (e) => {
        e.preventDefault();
        setSubmitLoading(true)
        HttpAPICall.withAthorization('POST', 'http://tappetbox.mysolutions.in/api/DeviceAsset', access_token, {}, formData, (resp) => {
            toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
            backToListing();
        }).then(() => setSubmitLoading(false));
    }
    const formInputHandler = (e) => {
        setFormData(pre => ({ ...pre, [e.target.name]: e.target.value }));
    };

    const formDatajsx = () => {
        return (
            <>
                <form className="bg-white p-3" onSubmit={submitDataForm} id="saveResourceForm">
                    {loading ? <Loader />
                        :
                        <>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label require">Device Type</label>
                                </div>
                                <div className="col-sm-8 ">
                                    <input
                                        name="device_type"
                                        type="text"
                                        value={formData.device_type}
                                        className="form-control"
                                        autoComplete="off"
                                        required={true}
                                        onChange={formInputHandler}
                                        placeholder="Please enter Device Type"

                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label require">Product Manufacturer</label>
                                </div>
                                <div className="col-sm-8 ">
                                    <input
                                        name="manufactureDeviceId"
                                        type="text"
                                        value={formData.manufactureDeviceId}
                                        className="form-control"
                                        autoComplete="off"
                                        required={true}
                                        onChange={formInputHandler}
                                        placeholder="Please enter Product Manufacturer"

                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label require">Product Model</label>
                                </div>
                                <div className="col-sm-8 ">
                                    <input
                                        name="deviceModel"
                                        type="text"
                                        value={formData.deviceModel}
                                        className="form-control"
                                        autoComplete="off"
                                        required={true}
                                        onChange={formInputHandler}
                                        placeholder="Please enter Product Model"

                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label require">Product Serial Number</label>
                                </div>
                                <div className="col-sm-8 ">
                                    <input
                                        name="product_serial_number"
                                        type="text"
                                        value={formData.product_serial_number}
                                        className="form-control"
                                        autoComplete="off"
                                        required={true}
                                        onChange={formInputHandler}
                                        placeholder="Please enter Product Serial Number"

                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label require">Imei Number</label>
                                </div>
                                <div className="col-sm-8 ">
                                    <input
                                        name="deviceIMEI"
                                        type="text"
                                        value={formData.deviceIMEI}
                                        className="form-control"
                                        autoComplete="off"
                                        required={true}
                                        onChange={formInputHandler}
                                        placeholder="Please enter Imei Number"

                                    />
                                </div>
                            </div>

                        </>
                    }
                    <div className="col-12 text-end fixed_footer">
                        <button type="button" className="btn btn-secondary mx-3" onClick={backToListing}>Cancel</button>
                        <button type="submit" className="btn btn-primary mx-2">
                            Save {submitLoading ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : ''}
                        </button>
                    </div>
                </form>
            </>
        );
    };
    const addDeviceJsx = () => {
        return (
            <>
                <div className="page_title row m0">
                    <div className="col-12">
                        <h3>Add</h3>
                        <div className="text-end mt15">
                            <>
                                <button type="button" className="btn btn-secondary" onClick={backToListing}>
                                    <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="item-action" />
                                </button>
                            </>
                        </div>
                    </div>
                </div>
                <div className="container-fluid pl5">
                    <div className="page_containt row">
                        <div className={['pageTbl', 'col-12'].join(' ')}>{formDatajsx()}</div>
                    </div>
                </div>
            </>
        );
    };
    return (
        <ApplicationLayout>
            <Helmet><title>Add Device</title></Helmet>
            {addDeviceJsx()}
        </ApplicationLayout>
    );
};

export default AddDevice;